export default __webpack_public_path__ + "static/media/footertwitter.8e0566fe.svg";